<template>
  <main-template>
    <v-container>
      <v-row align="center" class="mb-4">
        <v-col cols="auto">
          <v-btn
            id="circuitoNotas.voltarBtn"
            color="primary"
            icon
            @click="$router.push({ name: 'circuito-notas' })"
            :disabled="submittingForm"
          >
            <v-icon>fa fa-angle-left</v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <h2 class="text-h5 font-weight-medium mb-0">
            {{ editing ? "Editando" : "Criando" }} Circuito
          </h2>
        </v-col>
      </v-row>

      <ValidationObserver v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
          <v-row dense>
            <v-col cols="12" md="6">
              <ValidationProvider name="Descrição" rules="required" v-slot="{ errors }">
                <e-label>Descrição:</e-label>
                <v-text-field
                  id="circuitoNotas.descricaoInput"
                  v-model="formCircuito.descricao"
                  @change="(value) => deixarLetraMinuscula(value, 'descricao')"
                  :error-messages="errors"
                  dense
                  solo
                  placeholder="Ex: Circuito Avaliativo 1"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" md="6">
              <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Circuito:</e-label>
                <v-select
                  id="circuitoNotas.tipoSelect"
                  v-model="formCircuito.tipo"
                  :items="tipoCircuitos"
                  :error-messages="errors"
                  item-text="label"
                  item-value="value"
                  dense
                  outlined
                  placeholder="Selecione um tipo"
                  :disabled="editing"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" v-show="formCircuito.tipo === 'polivalencia'">
              <ValidationProvider
                name="Componentes Curriculares"
                :rules="formCircuito.tipo === 'polivalencia' ? 'required' : ''"
                v-slot="{ errors }"
              >
                <e-label>Componentes Curriculares usadas no Circuito:</e-label>
                <v-select
                  id="circuitoNotas.disciplinasSelect"
                  v-model="disciplinasSelecionadas"
                  :items="disciplinas"
                  :error-messages="errors"
                  item-text="descricao"
                  item-value="id"
                  outlined
                  multiple
                  dense
                  placeholder="Selecione os Componentes Curriculares"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12">
              <v-btn
                id="circuitoNotas.enviarDadosBtn"
                color="primary"
                type="submit"
                :loading="submittingForm"
                :disabled="submittingForm"
                block
              >
                Enviar Dados
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-container>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disciplinas: [],
      disciplinasSelecionadas: [],
      circuitoId: null,
      etapasByCircuito: [],
      submittingForm: false,
      circuitos: [],
      tipoCircuitos: [
        { label: "Notas em Letras", value: "letras" },
        { label: "Notas em Número", value: "numero" },
        { label: "Polivalência", value: "polivalencia" },
      ],
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    formCircuito() {
      if (!this.circuitos || !this.editing) return {};
      const { circuito_id } = this.$route.params;
      const circuito = this.circuitos.find((cir) => cir.id === parseInt(circuito_id, 10));

      return { ...circuito };
    },
  },
  mounted() {
    this.loadCircuitos();
    this.loadDataCircuito();
    this.verificarPermissao();
    this.getDisciplinas();
  },
  methods: {
    async getDisciplinas() {
      try {
        const disciplinas = await this.$services.disciplinasService.syncAll();
        this.disciplinas = disciplinas;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadCircuitos() {
      try {
        const data = await this.$services.circuitoNotasService.syncAll();
        this.circuitos = data;

        const circuitoAtual = this.circuitos.find(
          (cir) => cir.id === parseInt(this.$route.params.circuito_id, 10)
        );

        const raw = circuitoAtual?.disciplinas_do_ano;
        let disciplinas;
        if (Array.isArray(raw)) disciplinas = raw;
        else disciplinas = raw ? JSON.parse(raw) : [];

        this.disciplinasSelecionadas = disciplinas;
      } catch (error) {
        this.$handleError(error);
      }
    },
    deixarLetraMinuscula(value, campo) {
      const valor = value
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      this.formCircuito[campo] = valor;
    },
    async submitForm() {
      this.submittingForm = true;
      try {
        const circuitoPayload = { ...this.formCircuito };

        if (this.formCircuito.tipo === "polivalencia") {
          circuitoPayload.disciplinas = JSON.stringify(this.disciplinasSelecionadas);
        }

        if (this.editing) {
          await this.$services.circuitoNotasService.atualizarCircuito(circuitoPayload);
          this.$toast.success("Circuito atualizado com sucesso");
        } else {
          await this.$services.circuitoNotasService.criarCircuito(circuitoPayload);
          this.$toast.success("Circuito criado com sucesso");
        }

        this.$router.push({ name: "circuito-notas" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
    async loadDataCircuito() {
      try {
        if (this.circuitos.length === 0) {
          this.$loaderService.open("Carregando dados");
          await this.loadCircuitos();
          this.$loaderService.close();
        }
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async verificarPermissao() {
      if (this.user.roleName === "admin") {
        this.$toast.danger("Você não tem permissão para acessar essa página");
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 20px;
  margin-bottom: 10px;
}
</style>
